import sc from 'styled-components';

export const Container = sc.div`
  margin-bottom: 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;

  ul {
    li {
      color: #2D3748;
      font-size: 14px;
      span {
        padding: 0 .5rem;
        color: #a0aec0;
      }
    }
  }
`;